export default "__VITE_ASSET__DiJxyGJn__"